const STEP_PATHS = {
  rotation: "rotation",
  "field-operations": "field-operations",
  cultivation: "field-operations/cultivation",
  harvest: "harvest",
};

function getCropYearBasePath({ farmId, fieldId, cropyearId }) {
  return `/farm/${farmId}/field/${fieldId}/cropyear/${cropyearId}`;
}

function getCropYearStepPath(params, stepKey = "rotation") {
  const pathSuffix = STEP_PATHS[stepKey] || STEP_PATHS.rotation;
  return `${getCropYearBasePath(params)}/${pathSuffix}`;
}

function getCropYearRouteStep(pathname = "") {
  if (pathname.endsWith(`/${STEP_PATHS.cultivation}`)) {
    return "cultivation";
  }

  if (pathname.endsWith(`/${STEP_PATHS["field-operations"]}`)) {
    return "field-operations";
  }

  if (pathname.endsWith(`/${STEP_PATHS.harvest}`)) {
    return "harvest";
  }

  return "rotation";
}

function getCropYearStepIndex(stepKey = "rotation") {
  if (stepKey === "harvest") {
    return 2;
  }

  if (stepKey === "field-operations" || stepKey === "cultivation") {
    return 1;
  }

  return 0;
}

function getCropYearStepKey(index) {
  if (index === 2) {
    return "harvest";
  }

  if (index === 1) {
    return "field-operations";
  }

  return "rotation";
}

export {
  getCropYearBasePath,
  getCropYearRouteStep,
  getCropYearStepIndex,
  getCropYearStepKey,
  getCropYearStepPath,
};
